/**
 * The road to quantum computing — content for the history boards. Boards
 * reference entries by index, so wording can change without touching geometry.
 * (Starting draft; refine the copy freely.)
 */
export interface QuantumEvent {
  year: string;
  title: string;
  detail: string;
}

export const TIMELINE: readonly QuantumEvent[] = [
  {
    year: '1900',
    title: 'Planck',
    detail: 'Energy comes in discrete packets — quantum theory begins.',
  },
  {
    year: '1905',
    title: 'Einstein',
    detail: 'The photoelectric effect: light behaves as particles (photons).',
  },
  {
    year: '1913',
    title: 'Bohr',
    detail: 'Electrons occupy discrete energy levels around the atom.',
  },
  {
    year: '1924',
    title: 'de Broglie',
    detail: 'Matter has a wavelength — particles are also waves.',
  },
  {
    year: '1925',
    title: 'Heisenberg',
    detail: 'Matrix mechanics — the first formal quantum theory.',
  },
  { year: '1926', title: 'Schrödinger', detail: 'The wave equation and the wavefunction ψ.' },
  {
    year: '1927',
    title: 'Uncertainty',
    detail: 'You cannot know position and momentum exactly at once.',
  },
  {
    year: '1935',
    title: 'Entanglement',
    detail: 'EPR & Schrödinger expose spooky nonlocal correlations.',
  },
  {
    year: '1964',
    title: 'Bell',
    detail: "Bell's inequalities make nonlocality experimentally testable.",
  },
  { year: '1980', title: 'Benioff', detail: 'A quantum-mechanical model of computation.' },
  {
    year: '1981',
    title: 'Feynman',
    detail: '“To simulate physics, build a computer of quantum mechanics.”',
  },
  { year: '1985', title: 'Deutsch', detail: 'The first model of a universal quantum computer.' },
  {
    year: '1992',
    title: 'Deutsch–Jozsa',
    detail: 'An early algorithm with a clear quantum speedup.',
  },
  { year: '1994', title: 'Shor', detail: 'Factor large numbers fast — a threat to RSA.' },
  { year: '1996', title: 'Grover', detail: 'A quantum speedup for unstructured search.' },
  {
    year: '1996',
    title: 'Error correction',
    detail: 'Fragile quantum information can be protected from noise.',
  },
  {
    year: '2019',
    title: 'Quantum advantage',
    detail: 'A task run faster than known classical methods.',
  },
  {
    year: '2020s',
    title: 'Logical qubits',
    detail: 'From more qubits toward error-corrected, scalable machines.',
  },
];
